module.exports = __webpack_public_path__ + "static/img/SOS.121e8ca0.png";